<script lang="ts">
  import { _ } from 'svelte-i18n';

  import SizeFilters from '$lib/components/SizeFilters.svelte';
  import { companySizeRange } from '$lib/stores/selection';
  import { scheduleCount } from '$lib/stores/guided';

  /**
   * How large the companies are.
   *
   * # The panel's slider, not four bands
   *
   * This offered micro / small / medium / large as buttons, on the reasoning
   * that a customer who wants "small companies" should not have to decide
   * whether that means nine employees or ten. The cost was worse: the guide
   * offered less than the filter panel it hands over to, and the control
   * changed shape underneath anybody who left the guide after using it. The
   * bands also could not say "20 to 60", which is the kind of thing people
   * actually want.
   *
   * # Counting is watched, not called
   *
   * Same as the region and channel steps: the component owns the handles, so
   * the step watches the store they write rather than threading a callback
   * through four drag and input handlers.
   */
  $: void ($companySizeRange, scheduleCount());
</script>

<div class="space-y-5">
  <SizeFilters embedded />

  <p class="text-xs text-gray-500">{$_('guided.refine.mostStopHere')}</p>
</div>
